<template lang="pug">
.delete-regiao-modal(
    :class='isLoading ? "--loading" : ""'
    :style="{ maxWidth : '400px'}")
    .linha
        .coluna
            p Aceitar a exclusão da região {{ regiao?.nome }} implica em perder as informações gereciadas por ela e os municípios serão adicionados na região padrão. Deseja prosseguir?

    .linha.acoes(:style="{ marginTop : '40px'}")
        button-component(
            background-color='var(--primary-light-red)',
            icon='mdi-trash-can-outline',
            label='Excluir',
            @click.native='deletar'
        )
        button-component(
            icon='mdi-close',
            background-color='var(--primary-dark-smoke)',
            label='Cancelar',
            @click.native='cancelar'
        )
</template>

<script>
import {
    deletar
} from '@/services/regiaoAnalise.service';

export default {

    name: 'DeleteRegiaoModal',

    props: {
        regiao: Object
    },

    data() {
        return {
            isLoading: false
        };
    },

    methods: {

        async deletar() {

            this.isLoading = true;
            let result = await deletar(this.regiao.id);
            if (result.status === 200) {
                this.$toast({
                    showClose: true,
                    message: 'Região excluida com sucesso!',
                    type: 'success'
                });
                this.isLoading = false;
                this.cancelar();
                this.$router.go();
            } else {
                this.$toast({
                    showClose: true,
                    message: 'Erro ao excluir região! : ' + result.message,
                    type: 'error'
                });
                this.isLoading = false;
                this.cancelar();
            }
        },

        cancelar() {
            this.$emit('cancelar', true);
        }
    }
}
</script>

<style lang="scss" scoped>
.acoes {
    display: flex;
    justify-content: space-between;
}

.delete-regiao-modal .--loading {
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
    background-color: var(--primary-smoke);
    background-image: url('../../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
}
</style>
